import { stoageGetter } from "../../helpers";


export const tabMenuList = (isManagerView) => {
const login_user_data = stoageGetter("user");

  console.log("dataaaaaaaaa", isManagerView, login_user_data)

const isRMmapped = login_user_data?.reportingManager?.employeeCode ? true : false;
const isRMself = (login_user_data?.reportingManager?.employeeCode === login_user_data?.employeeCode) ? true : false;
const isSupervisorApprovalFlag = (login_user_data?.channelCode?.supervisorApprovalFlag) ? true : false;

// Supervisor Approval is shown if:
// Feature is enabled
// RM is mapped
// User is either in Manager View OR is not their own RM.
  const isSupervisorApprovalRequired =
    isSupervisorApprovalFlag &&
    isRMmapped &&
    (isManagerView || !isRMself);

console.log("isSupervisorApprovalRequired", isSupervisorApprovalRequired)

return [
  {
    id: "benefitIllustrator",
    value: "Benefit Illustrator",
  },
  {
    id: "kycDetails",
    value: "KYC Details",
  },
  {
    id: "uploaddocuments",
    value: "Mandatory Document Upload",
  },
  {
    id: "ProposalFormFilling",
    value: "Proposal Form Filling",
  },
  {
    id: "uploaddynamicdocuments",
    value: "Dynamic Document Upload",
  },
  ...(isSupervisorApprovalRequired
    ? [
      {
        id: "supervisorApproval",
        value: "Supervisor Approval",
      },
    ]
    : []),
  {
    id: "oTPAuthentication",
    value: "OTP Authentication",
  },
  {
    id: "payments",
    value: "Payment",
  },
  {
    id: "esir",
    value: "E-SIR Authentication",
  },
  {
    id: "finalSubmit",
    value: "Document Submitted",
  },
];
}

console.log("TABLIST,", tabMenuList)